import { Controller } from "@hotwired/stimulus"

// 利用規約モーダル表示用のStimulus Controller
// Turbo Frame更新後も正常に動作する
export class SimpleModalController extends Controller {
  static targets = ["modal"]

  open() {
    this.modalTarget.style.display = 'block'
    setTimeout(() => {
      this.modalTarget.style.opacity = '1'
    }, 10)
    this.#lockBodyScroll()
  }

  close() {
    this.modalTarget.style.opacity = '0'
    setTimeout(() => {
      this.modalTarget.style.display = 'none'
    }, 300)
    this.#unlockBodyScroll()
  }

  // モーダル背景クリック時（モーダル要素自体がクリックされた場合のみ閉じる）
  clickOutside(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  // Private methods
  #lockBodyScroll() {
    this.element.ownerDocument.body.style.overflow = 'hidden'
  }

  #unlockBodyScroll() {
    this.element.ownerDocument.body.style.overflow = ''
  }
}
